export const lastComit = {
  // git log -1 --format=%cd origin/develop
  develop: '14.04.2021 17:24:00',
  // git log -1 --format=%cd origin/homolog
  homolog: '14.04.2021 17:30:00',
} as { develop: string; homolog: string };
